module.exports = __webpack_public_path__ + "static/media/Seam_5731.52da9035.jpg";